import React from 'react';
import { Box } from '@mui/material';
import { Positions } from './Positions';

export const SimpleView = props => {
  const { positions, order } = props;

  return (
    <Box sx={{ flex: 1 }}>
      <Positions positions={positions} order={order} height={380}></Positions>
    </Box>
  );
};
